import { render, staticRenderFns } from "./VisionTitle.vue?vue&type=template&id=78f65015&"
import script from "./VisionTitle.vue?vue&type=script&lang=js&"
export * from "./VisionTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports